import { render, staticRenderFns } from "./AmazonStarRating.vue?vue&type=template&id=1ea7660d"
import script from "./AmazonStarRating.vue?vue&type=script&lang=js"
export * from "./AmazonStarRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports